import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import Select from "react-select";

const DEPARTMENt = gql`
query Departments($where: DepartmentWhereInput, $orderBy: OrderByInput, $limit: Int) {
  departments(where: $where, orderBy: $orderBy, limit: $limit) {
    total
    data {
      _id
      title_lao
      title_eng
    }
  }
}
`;

export default function SelectDepartment({ className, style, onChange, disabled, value }) {
  const [getData, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [fetchData, { data, loading }] = useLazyQuery(DEPARTMENt);

  useEffect(() => {
    fetchData({
      variables: {
        where: {
        },
      },
    });
  }, []);

  useEffect(() => {
    const results = data?.departments?.data || [];
    if (results?.length > 0) {
      const _results = results.map((_data) => {
        const object = {
          ..._data,
          value: _data?._id,
          label: _data?.title_lao + " / " + _data?.title_eng,
        };
        return object;
      });
      setData(_results);
    } else {
      setData([]);
    }
  }, [data]);

  //set value
  useEffect(() => {
    if (value) {
      const result = getData?.filter((_data) => _data?._id === value);
      setSelectedOption(result[0] || null);
    } else {
      setSelectedOption(null);
    }
  }, [getData, value]);

  return (
    <div style={{ minWidth: 200, color: "black", fontSize: 16, marginTop: 7 }}>
      <Select
        styles={style}
        className={className}
        isDisabled={disabled}
        value={selectedOption}
        placeholder={loading ? "ກຳລັງໂຫຼດ..." : "ເລືອກພະແນກ..."}
        onChange={(res) => {
          setSelectedOption(res);
          if (onChange) {
            onChange(res);
          }
        }}
        options={getData}
      />
    </div>
  );
}
